import React from 'react';
import { motion } from 'framer-motion';
import { embed, embedSteps } from '../../../data/snak2';
const EASE = [0.23, 1, 0.32, 1] as const;
export function EmbedScreen() {
  return <div className="flex flex-1 flex-col" data-id="element-644" data-mp="6d4cqfhshcag">
      <motion.h2 initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      ease: EASE
    }} className="font-display text-[25px] font-semibold leading-[1.08] tracking-tight text-ozNavy" data-id="element-645" data-mp="6e5o6l2pw0sp">
        {embed.headline}
      </motion.h2>

      <p className="mt-3 text-[12.5px] leading-relaxed text-mut" data-id="element-646" data-mp="3etfnxmj4wtxb">{embed.lead}</p>

      <ol className="relative mt-5 flex flex-col gap-3.5 pl-[26px]" data-id="element-647" data-mp="3jqpkrn8us7v6">
        <span className="absolute bottom-3 left-[9px] top-3 w-px bg-line" aria-hidden="true" data-id="element-648" data-mp="3oqkc1rwjizgr" />
        {embedSteps.map((step, i) => <motion.li key={step.title} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.24,
        delay: 0.08 + i * 0.06,
        ease: EASE
      }} className="relative" data-id="element-649" data-mp="z0gr42dsqdso" data-mpi={i}>
            <span className="absolute -left-[26px] top-[2px] flex h-[19px] w-[19px] items-center justify-center rounded-full bg-ozGreen text-[8.5px] font-bold tabular-nums text-ozNavy" aria-hidden="true" data-id="element-650" data-mp="3ecz02eflm24w">
              {i + 1}
            </span>
            <p className="text-[13px] font-semibold leading-snug text-ozNavy" data-id="element-651" data-mp="34gw2llvoyroa">{step.title}</p>
            <p className="mt-0.5 text-[11.5px] leading-snug text-mut" data-id="element-652" data-mp="2zh9o7944n5dw">{step.detail}</p>
          </motion.li>)}
      </ol>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.38,
      ease: EASE
    }} className="mt-auto pt-5" data-id="element-653" data-mp="2qmljpl6dlrq5">
        <div className="rounded-xl bg-ozMist px-4 py-3.5" data-id="element-654" data-mp="2gpgwdi0snq7r">
          <p className="text-[9px] uppercase tracking-micro text-ozBlue" data-id="element-655" data-mp="2gr1qx7n3z95m">{embed.tuesdayLabel}</p>
          <p className="mt-2 font-display text-[16px] font-semibold leading-snug text-ozNavy" data-id="element-656" data-mp="2brxe870z6taj">
            {embed.tuesdayLine}
          </p>
        </div>
      </motion.div>
    </div>;
}